import { Tag } from '../../model/tagging/Tag';
import '../../model/tagging/TagFormElementText';

import { Factory } from '../../services/Factory';

namespace app.directives.tagging {
  import IDirective = angular.IDirective;
  import IScope = angular.IScope;

  export class TagFormElement implements IDirective {
    public restrict: string = "A";
    public scope = false;
    public link: (scope: IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => void;
    public templateUrl: string;

    constructor($uibModal, tagService: app.services.tagging.TagService, notificationService: app.services.INotificationService, preferenceService: app.services.user.PreferenceService, tagFormElementDataService: app.services.tagging.TagFormElementDataService) {
      this.templateUrl = "partials/tagging/admin_tag_input.html";
      this.link = (scope: IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        if (scope.option.tag)
          scope.option.tagToFind = scope.option.tag;

        if (!scope.selected) {
          scope.selected = [];
        }

        attrs.$observe("name", val => scope.name = val);

        scope.$watch("option.tag", val => scope.option.validTag = _.isObject(val));

        scope.$watch("resource.tags", (val: Array<Tag>) => {
          scope.option.found = false;
          scope.option.inverseFound = false;

          if (angular.isArray(val)) {
            val.forEach(tag => {
              if (scope.option.tag && tag.id == scope.option.tag.id) {
                scope.option.selected = tag.id;
                scope.option.found = true;
              }

              if (scope.option.inverseTag && tag.id == scope.option.inverseTag.id) {
                scope.option.selected = tag.id;
                scope.option.inverseFound = true;
              }
            });
          }

          if (!scope.option.found && !scope.option.inverseFound) {
            scope.option.selected = 0;
          }

          if (scope.option.found && scope.option.children && scope.option.children.length > 0) {
            scope.option.children.forEach(childVal => childVal.selected = !!_.findWhere(val, {id: childVal.id}));
          } else if (scope.option.inverseFound && scope.option.inverseChildren && scope.option.inverseChildren.length > 0) {
            scope.option.inverseChildren.forEach(childVal => childVal.selected = !!_.findWhere(val, {id: childVal.id}));
          }
        });

        scope.$watch("option.selected", val => {
          if (!scope.tagAdmin) {
            if (scope.option.tag && val == scope.option.tag.id && !scope.option.found) {
              scope.addTag(scope.option.tag, false, false);
            } else if (scope.option.inverseTag && val == scope.option.inverseTag.id && !scope.option.inverseFound) {
              scope.addTag(scope.option.inverseTag, true, false);
            } else if (val == 0 && scope.option.found) {
              scope.removeTag(scope.option.tag, false);
            }
          }
        });

        scope.$watch("resource", (resource: any) => {
          if (scope.watchValuesHandle) {
            scope.watchValuesHandle();
          }

          if (resource) {
            tagFormElementDataService.Get(resource.projectId, resource.collectionId, resource.id, scope.option.id).then(values => {
              scope.option.values = _.map(values, (v: any) => {
                return {id: v.id, name: v.value};
              });

              scope.watchValues();
            });
          }
        });

        scope.watchValues = () => {
          scope.watchValuesHandle = scope.$watch("option.values", (current: string[], prev: string[]) => {
            if (current && current !== prev) {
              let item;

              if (current.length > prev.length) {
                item = _.without(current, ...prev)[0];
                tagFormElementDataService.Save(scope.resource.projectId, scope.resource.collectionId, scope.resource.id, {
                  tagFormElementId: scope.option.id,
                  value: item.name
                }).then(i => {
                  item.id = i.id;
                });
              } else {
                item = _.without(prev, ...current)[0];
                tagFormElementDataService.Delete(scope.resource.projectId, scope.resource.collectionId, scope.resource.id, item.id);
              }
            }
          });
        };

        scope.addChildTag = tag => {
          if (!scope.tagAdmin) {
            if (tag.selected) {
              scope.addTag(tag, false, true);
            } else {
              scope.removeTag(tag, true);
            }
          }
        };

        scope.add = () => {
          console.log("Adding: ", scope.option);
          if (scope.option.type === 'text') {
            scope.option = {...new app.model.tagging.TagFormElementText({...scope.option}), ...scope.option};
            scope.option.editMode = false;
            scope.$emit("ItemAddedToForm", {option: scope.option, index: scope.$index});
          } else if (scope.option.validTag) {
            scope.option.editMode = false;
            scope.$emit("ItemAddedToForm", {option: scope.option, index: scope.$index});
          }
        };

        scope.cancel = () => {
          console.log("Cancelling: ", scope.option);
          if (scope.option.tag) {
            scope.option.tagToFind = scope.option.tag;
            scope.option.editMode = false;
          } else if (!scope.option.name) {
            scope.remove(scope.option);
          } else {
            scope.option.editMode = false;
          }
        };

        scope.edit = () => {
          scope.option.tagToFind = scope.option.tag;
          scope.option.editMode = true;
        };


        scope.getSuggestions = val => {
          const categoryBitmask = 4; // only project
          return tagService.GetSuggestions(scope.project.id, val, categoryBitmask, true,
            scope.hasInverse(), false, true).then(response => response.data);
        };


        scope.onSelect = $item => {
          scope.option = {
            ...new TagFormElementTag({
              ...$item,
              id: "",
              tagId: $item.id,
              editMode: true,
              tag: $item,
              inverseTag: $item.inverses && $item.inverses.length > 0 ? $item.inverses[0] : null
            }), ...scope.option
          };
        };

        scope.hasInverse = () => scope.option.type === "radio";

        scope.addTag = (tag, isInverse, isChild) => {
          if (!scope.tagAdmin) {
            tagService.TagResource(scope.project, scope.collection, scope.resource, tag.name, preferenceService.Get(app.model.user.Preferences.TAG_RELATED), () => {
              scope.tag = null;
              scope.saving = false;
              if (!isChild && isInverse) {
                scope.option.found = false;
                scope.option.inverseFound = true;
              } else if (!isChild) {
                scope.option.inverseFound = false;
                scope.option.found = true;
              }
            });
          }
        };

        scope.removeTag = (tag, isChild) => {
          if (!scope.tagAdmin) {
            tagService.UntagResource(scope.project, scope.collection, scope.resource, null, tag, () => scope.option.found = !!isChild, preferenceService.Get(app.model.user.Preferences.TAG_RELATED));
          }
        };

        scope.remove = option => scope.$emit("RemoveTagOption", option);

        scope.openAddTagDialog = tag => {
          tag.isNameEditable = true;
          const modalInstance = $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: "partials/tagging/dialog_add_tag.html",
            controller: "AddTagModalCtrl",
            scope: scope,
            resolve: {
              project: () => scope.project,
              tag: () => tag
            }
          });

          modalInstance.result.then(() => scope.option.editMode = false, null);
        };
      }
    }
  }

  frontendApp.directive("iioTagFormElement", ["$uibModal", "TagService", "NotificationService", "PreferenceService", "TagFormElementDataService", Factory.Create(TagFormElement)]);
}
